import { Card, InputLabel, Stack, Typography } from '@mui/material';
import Grid from '@mui/material/Grid';

import useStyles from './ViewDataProviders.styles';
import type { GoogleStorageProvidersProps } from './ViewDataProviders.types';

const GoogleStorageProviders = ({ providers }: GoogleStorageProvidersProps) => {
  const { classes } = useStyles();
  const entries = Object.entries(providers);

  if (!entries.length) {
    return (
      <Typography color="text.secondary">
        No Google Storage data providers configured
      </Typography>
    );
  }

  return (
    <Stack spacing={1}>
      <Card variant="outlined" sx={{ px: 2, py: 2 }}>
        {entries.map(([name, provider]) => (
          <Grid
            key={name}
            container
            spacing={1}
            className={classes.cardGridLayout}
          >
            <Grid sx={{ display: 'flex' }} size={{ xs: 12 }}>
              <InputLabel sx={{ flexGrow: 1 }}>Name</InputLabel>
              <Typography>{name}</Typography>
            </Grid>

            <Grid sx={{ display: 'flex' }} size={{ xs: 12 }}>
              <InputLabel sx={{ flexGrow: 1 }}>Directory Path</InputLabel>
              <Typography style={{ textAlign: 'right' }}>
                {provider.directory_path}
              </Typography>
            </Grid>
          </Grid>
        ))}
      </Card>
    </Stack>
  );
};

export default GoogleStorageProviders;
